import React, { useState, useEffect } from 'react'
import { Form, Input, Modal, Button, App } from 'antd';
import { useKehukpxxUpdateSaveMutation, useKehukpxxDelMutation } from '../../store/DianShangYeWuApi';
function ClientInvoiceEdit(props) {
    const { message, modal } = App.useApp();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        'khkpxx_kh_id': props.kh_id,
        'khkpxx_type_id': '1',
        'khkpxx_type_name': '1',
        'khkpxx_name': props.khkpxx_name,
        'khkpxx_code': props.khkpxx_code,
        'khkpxx_cid': props.yh_id,
        'khkpxx_cname': props.yh_name,
        'khkpxx_content': props.khkpxx_content,
        'khkpxx_id': props.khkpxx_id,
        'khkpxx_update_uname': props.yh_name,
        'khkpxx_dizhi': props.khkpxx_dizhi,
        'khkpxx_khh': props.khkpxx_khh,
        'khkpxx_yhzh': props.khkpxx_yhzh,
        'khkpxx_dh': props.khkpxx_dh,
    });
    const [form] = Form.useForm();
    useEffect(() => {
        if(open){
            form.setFieldsValue({
                khkpxx_name: props.khkpxx_name,
                khkpxx_code: props.khkpxx_code,
                khkpxx_content: props.khkpxx_content,
                khkpxx_dizhi: props.khkpxx_dizhi,
                khkpxx_khh: props.khkpxx_khh,
                khkpxx_yhzh: props.khkpxx_yhzh,
                khkpxx_dh: props.khkpxx_dh,
            });
        }
    },[open, props, form]);
    const [updateSave] = useKehukpxxUpdateSaveMutation();
    const [del] = useKehukpxxDelMutation();
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.khkpxx_name}</a>
            <Modal
                open={open}
                width={800}
                onCancel={() => {setOpen(false)}} 
                title={props.kh_name}
                footer={[
                    <Button 
                        type='primary' 
                        key='save' 
                        onClick={() => {
                            updateSave(info).then(res => {
                                if(res.data.Status === 'success'){
                                    message.success('修改成功');
                                    setOpen(false);
                                    form.resetFields();
                                }else{
                                    message.error('修改失败'+res.data.Message);
                                }
                            });
                        }}
                    >保存</Button>,
                    <Button 
                        key='cancel' 
                        onClick={() => {
                            modal.confirm({
                                title: '确定删除该开票信息吗？',
                                content: '删除后不能恢复！',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk: () => {
                                    del({khkpxx_id: props.khkpxx_id}).then(res => {
                                        if(res.data.Status === 'success'){
                                            message.success('删除成功');
                                            setOpen(false);
                                            form.resetFields();
                                        }else{
                                            message.error('删除失败'+res.data.Message);
                                        }
                                    });
                                }
                            }); 
                        }}
                    >删除</Button>,
                ]}
            >
                <Form 
                    form={form} 
                    name={`form_client_invoice_edit_${props.khkpxx_id}`} 
                    labelCol={{span: 4}} 
                    wrapperCol={{span: 20}}
                >
                    <Form.Item name='khkpxx_name' label='单位名称' rules={[{ required: true, message: '请输入单位名称' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_name: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_code' label='企业代码' rules={[{ required: true, message: '请输入企业代码' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_code: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_dizhi' label='地址'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_dizhi: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_khh' label='开户行'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_khh: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_yhzh' label='银行账号'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_yhzh: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_dh' label='电话'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_dh: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_content' label='备注'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_content: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item label='新增记录' >
                        {props.khkpxx_ctime} {props.khkpxx_cname}
                    </Form.Item>
                    <Form.Item label='修改记录' >
                        {props.khkpxx_update_time} {props.khkpxx_update_uname}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientInvoiceEdit